<template>
  <div>
    <h1 class="text-h5 font-weight-bold mb-4">Ventas por mes</h1>

    <!-- Panel de filtros -->
    <v-card outlined class="mb-4 pa-4">
      <div class="caption">Filtros</div>
      <v-row dense align="center" justify="start" no-gutters>
        <v-col cols="12" md="3">
          <SucursalesVFilter />
        </v-col>

        <v-col cols="12" md="3">
          <v-select
            v-model="anio1"
            :items="anios"
            label="Período principal"
            outlined
            dense
            hide-details
          />
        </v-col>

        <v-col cols="12" md="3" class="ml-1">
          <v-select
            v-model="anio2"
            :items="anios_pasados"
            label="Comparar con"
            outlined
            dense
            hide-details
          />
        </v-col>
      </v-row>
    </v-card>

    <!-- Gráficos o skeleton -->
    <v-row>
      <template v-if="loaded">
        <v-col
          v-for="sucursal in ventasPorSucursal"
          :key="sucursal.nombre"
          cols="12"
          md="6"
        >
          <v-card outlined elevation="2" class="pa-3 mb-4">
            <v-card-title class="subtitle-1 font-weight-bold">
              {{ sucursal.nombre }}
            </v-card-title>
            <v-card-text>
              <bar-chart :chartdata="sucursal.chartData" :options="options" />
            </v-card-text>
          </v-card>
        </v-col>
      </template>

      <template v-else>
        <v-col v-for="n in 2" :key="n" cols="12" md="6">
          <v-skeleton-loader type="card" class="mb-4" />
        </v-col>
      </template>
    </v-row>
  </div>
</template>

<script>
import BarChart from "@/chartjs/bar.chart.vue";
import ReportesAPI from "@/api/reportes";
import SucursalesVFilter from "@/components/sucursal/SucursalesVFilter.vue";

export default {
  name: "EmpresaReporteVentaPorMes",
  components: { BarChart, SucursalesVFilter },
  data() {
    return {
      ventasPorSucursal: [],
      loaded: false,
      anios: [],
      anios_pasados: [],
      anio1: new Date().getFullYear(),
      anio2: new Date().getFullYear() - 1,
      options: {
        legend: { position: "bottom", labels: { usePointStyle: true } },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value) {
                  return (
                    "$" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  );
                },
              },
              scaleLabel: { display: true, labelString: "Ventas" },
            },
          ],
          xAxes: [
            {
              ticks: { autoSkip: false, maxRotation: 0, minRotation: 0 },
              // barThickness: 20,
              categoryPercentage: 0.7,
              barPercentage: 0.8,
              offset: true,
              scaleLabel: { display: true, labelString: "Meses" },
            },
          ],
        },

        tooltips: {
          enabled: true,
          mode: "index",
          intersect: false,
          bodyFontSize: 16, // tamaño del texto del body
          titleFontSize: 18, // tamaño del título (mes)
          bodyFontStyle: "bold", // texto en negrita
          titleFontStyle: "bold",
          callbacks: {
            label: function (tooltipItem) {
              return (
                "$" +
                Number(tooltipItem.yLabel).toLocaleString("es-AR", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })
              );
            },
          },
          backgroundColor: "rgba(0,0,0,0.8)", // fondo del tooltip
          titleFontColor: "#ffffff",
          bodyFontColor: "#ffffff",
          xPadding: 10,
          yPadding: 10,
          caretSize: 6,
        },
        animation: { duration: 500 },
        responsiveAnimationDuration: 2,
        maintainAspectRatio: false,
      },
    };
  },
  methods: {
    fetchVentasMensual() {
      this.loaded = false;
      const sucursal = this.$route.query.uuid_sucursal || null;
      const meses = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

      ReportesAPI.getVentasComparativo(this.anio1, this.anio2, sucursal)
        .then((response) => {
          const { anio1, anio2, sucursales } = response.data;
          this.ventasPorSucursal = sucursales.map((s) => ({
            nombre: s.nombre,
            chartData: {
              labels: meses,
              datasets: [
                { label: String(anio1), backgroundColor: "#42A5F5", data: s.anio1 },
                { label: String(anio2), backgroundColor: "#66BB6A", data: s.anio2 },
              ],
            },
          }));
          this.loaded = true;
        });
    },
  },
  watch: {
    anio1: "fetchVentasMensual",
    anio2: "fetchVentasMensual",
    "$route.query.uuid_sucursal"() {
      this.fetchVentasMensual();
    },
  },
  created() {
    const currentYear = new Date().getFullYear();
    const range = Array.from({ length: 5 }, (_, i) => currentYear - i);
    this.anios = range;
    this.anios_pasados = range;
    this.fetchVentasMensual();
  },
};
</script>
